import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from 'app/utils/utils';

export const leadApi = createApi({
  reducerPath: 'lead',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL + '/lead/versions/1/',
    mode: 'cors',
  }),
  endpoints: (build) => ({
    createLead: build.mutation<any, any>({
      query: ({ body, token }) => ({
        url: 'leads',
        withCredentials: false,
        method: 'POST',
        headers: { 'Ais-Captcha-Token': token },
        body,
      }),
    }),
  }),
});

export const { useCreateLeadMutation } = leadApi;
